import Facade from '@/Facade'
import GameSignals from '@/signals/GameSignals'
import { BaseState } from '@/stateMachine/BaseState'
import { GameStatesEnum } from '@/states/GameStatesEnum'

export class HoldAndWinIntroState extends BaseState {
    private _isWaitingIntroComplete: boolean = false

    public begin(): void {
        this._model.isBonusGameNow = true
        this._model.spinState.isHoldAndWinActive = true

        // Mid-FS consecutive H&W skips StartRoundState, so clear per-feature gates here.
        ;(Facade as any).holdAndWinSummaryConsumed = false
        ;(Facade as any).holdAndWinWinMeterCommitted = false
        ;(Facade as any).skipFinalWinPresentationAfterHoldAndWin = false

        this._isWaitingIntroComplete = true
        ;(GameSignals as any).featureIntroContinue?.connect(this.onIntroComplete)
        ;(GameSignals as any).featureIntroRequested?.emit({ kind: 'holdandwin' })
    }

    private onIntroComplete = (): void => {
        if (!this._isWaitingIntroComplete) {
            return
        }

        this._isWaitingIntroComplete = false
        ;(GameSignals as any).featureIntroContinue?.disconnect(this.onIntroComplete)

        const isBuyBonusSpin = !!this._model.isBuyBonusPending
        const spinBet = isBuyBonusSpin && this._model.bonusBuyBet ? this._model.bonusBuyBet : this._model.currentSpinBet

        ;(GameSignals as any).holdAndWinStartSpin?.emit()
        GameSignals.startSpin.emit(spinBet)
        this.end()
    }

    public end = (): void => {
        this._stateMachine.setState(GameStatesEnum.GET_SPIN_RESPONSE_STATE)
    }

    public cleanUp(): void {
        this._isWaitingIntroComplete = false
        ;(GameSignals as any).featureIntroContinue?.disconnect(this.onIntroComplete)
    }
}
